import { gql } from 'apollo-boost'

const SCRAPING_TEST_CASE_COUNTS_BY_TAG_TYPES = gql`
  query scrapingTestCaseCountsByTagTypes($tagIds: [ID!]) {
    scrapingTestCaseCountsByTagTypes(tagIds: $tagIds) {
      type
      name
      count
    }
  }
`

export default SCRAPING_TEST_CASE_COUNTS_BY_TAG_TYPES
